






















































































































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Select2, Select, TextArea, Radio } from '@/components/form'
import { DatePicker } from '@/components/general'
import HeaderFormSelectArea from '../HeaderFormSelectArea.vue'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'

// models
import { LoanControlForm } from '@/models/dailyControl'
import { IEmployee } from '@/models/config'
import { PropOptionSelect } from '@/models'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'
import { getListDateAvailable } from '@/utils/employee'

// constants
import { frequencyOptions } from '@/constants/generals'

// services
import { LoanControlsService } from '@/services/dailyControl'

@Component({
    name: 'FormCreateEditLoanControl',
    components: {
        Input,
        Select2,
        DatePicker,
        TextArea,
        Select,
        Radio,
        HeaderFormSelectArea
    },
    mixins: [validationMixin]
})
export default class FormCreateEditLoanControl extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) loanControl!: LoanControlForm
    @Prop({ type: Number, default: null }) idEdit!: number|null
    @Prop({ type: Array, default: () => [] }) employees!: IEmployee[]

    form: LoanControlForm = {
        employee_id: null,
        date: '',
        date_start_discount: '',
        amount: 0,
        dues: 0,
        frequency: 1,
        reason: ''
    }

    frequencyOp = frequencyOptions
    dateAvailable: string[] = []
    typeForm = 1
    optionsTypeForm = [
        {
            text: 'POR EMPLEADO',
            value: 1
        },
        {
            text: 'POR ÁREA',
            value: 2
        }
    ]

    areaSelectedId: number|null = null
    subAreaSelectedId: number|null = null
    employeesSelected: number[] = []

    get employeeSelected (): IEmployee | null {
        if (this.form.employee_id && this.employeesOp.find(employee => employee.value === this.form.employee_id)) {
            const employee = this.employees.find(e => e.id === this.form.employee_id)
            if (employee) {
                return employee
            }
        }
        return null
    }

    get employeesOp (): PropOptionSelect[] {
        return this.employees.filter(employee => (this.actionForm === 'save' && this.typeForm === 2) ? Number(employee.assignment.sub_area_id) === Number(this.subAreaSelectedId) : true).map(employee => {
            return {
                value: employee.id ?? null,
                text: getFullNameFormat(employee)
            }
        })
    }

    created () {
        if (this.idEdit) {
            this.form = this.loanControl
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                employee_id: {
                    required: requiredIf(() => this.actionForm !== 'save' || this.typeForm === 1)
                },
                date: { required },
                date_start_discount: { required },
                amount: { required },
                dues: { required },
                cuotasg: { required },
                frequency: { required },
                reason: { required }
            },
            areaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            subAreaSelectedId: {
                required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2)
            },
            employeesSelected: { required: requiredIf(() => this.actionForm === 'save' && this.typeForm === 2), minLength: 1 }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await LoanControlsService.update(this.idEdit, this.form)
                } else {
                    if (this.typeForm === 2) {
                        for (let i = 0; i < this.employeesSelected.length; i++) {
                            this.form.employee_id = this.employeesSelected[i]
                            const result = await LoanControlsService.validateExists(null, this.form)
                            if (!result.success) {
                                const employee = this.employeesOp.find(employee => Number(employee.value) === Number(this.form.employee_id))
                                let message = ''
                                if (employee) {
                                    message = `El empleado: ${employee.text}, ${result.msg}`
                                }
                                alerts.error(message)
                                loading('hide')
                                return
                            }
                        }
                        for (let i = 0; i < this.employeesSelected.length; i++) {
                            this.form.employee_id = this.employeesSelected[i]
                            await LoanControlsService.create(this.form)
                        }
                    } else {
                        await LoanControlsService.create(this.form)
                    }
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    employee_id: null,
                    date: '',
                    date_start_discount: '',
                    amount: 0,
                    dues: 0,
                    cuotasg: 0,
                    frequency: 1,
                    reason: ''
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error(String(e))
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }

    setListDateAvailable () {
        if (this.form.employee_id && this.employeeSelected) {
            const listDate = getListDateAvailable(this.employeeSelected.cessation)
            this.dateAvailable = listDate
        }
    }

    setAllEmployeesBySubArea (subAreaSelectedId: number) {
        this.form.employee_id = null
        this.subAreaSelectedId = subAreaSelectedId
        if (subAreaSelectedId) {
            this.employeesSelected = this.employees.filter(employee => Number(employee.assignment.sub_area_id) === Number(subAreaSelectedId)).map(employee => employee.id)
        } else {
            this.employeesSelected = []
        }
    }
}
